import { render, staticRenderFns } from "./platformOrderLogDetailsModal.vue?vue&type=template&id=0387229a"
import script from "./platformOrderLogDetailsModal.vue?vue&type=script&lang=js"
export * from "./platformOrderLogDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports